/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ClientGoalDto,
  GetClientGoalsParams,
  PagedModelClientGoalDto
} from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType , BodyType } from '../../orval-mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Authorities: **Any authenticated role**
 */
export const getClientGoalById = (
    userId: string,
    clientId: number,
    id: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ClientGoalDto>(
      {url: `/api/${userId}/clients/${clientId}/goals/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetClientGoalByIdQueryKey = (userId: string,
    clientId: number,
    id: number,) => {
    return [
    `/api/${userId}/clients/${clientId}/goals/${id}`
    ] as const;
    }


export const getGetClientGoalByIdQueryOptions = <TData = Awaited<ReturnType<typeof getClientGoalById>>, TError = ErrorType<unknown>>(userId: string,
    clientId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientGoalById>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientGoalByIdQueryKey(userId,clientId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientGoalById>>> = ({ signal }) => getClientGoalById(userId,clientId,id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: !!(userId && clientId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClientGoalById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetClientGoalByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getClientGoalById>>>
export type GetClientGoalByIdQueryError = ErrorType<unknown>


export function useGetClientGoalById<TData = Awaited<ReturnType<typeof getClientGoalById>>, TError = ErrorType<unknown>>(
 userId: string,
    clientId: number,
    id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientGoalById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientGoalById>>,
          TError,
          Awaited<ReturnType<typeof getClientGoalById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientGoalById<TData = Awaited<ReturnType<typeof getClientGoalById>>, TError = ErrorType<unknown>>(
 userId: string,
    clientId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientGoalById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientGoalById>>,
          TError,
          Awaited<ReturnType<typeof getClientGoalById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientGoalById<TData = Awaited<ReturnType<typeof getClientGoalById>>, TError = ErrorType<unknown>>(
 userId: string,
    clientId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientGoalById>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetClientGoalById<TData = Awaited<ReturnType<typeof getClientGoalById>>, TError = ErrorType<unknown>>(
 userId: string,
    clientId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientGoalById>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetClientGoalByIdQueryOptions(userId,clientId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_CLIENT_SERVICE, ROLE_REPORT_ADMIN**<br /><br />
 */
export const updateClientGoal = (
    userId: string,
    clientId: number,
    id: number,
    clientGoalDto: BodyType<ClientGoalDto>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ClientGoalDto>(
      {url: `/api/${userId}/clients/${clientId}/goals/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: clientGoalDto, signal
    },
      options);
    }



export const getUpdateClientGoalMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateClientGoal>>, TError,{userId: string;clientId: number;id: number;data: BodyType<ClientGoalDto>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof updateClientGoal>>, TError,{userId: string;clientId: number;id: number;data: BodyType<ClientGoalDto>}, TContext> => {

const mutationKey = ['updateClientGoal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateClientGoal>>, {userId: string;clientId: number;id: number;data: BodyType<ClientGoalDto>}> = (props) => {
          const {userId,clientId,id,data} = props ?? {};

          return  updateClientGoal(userId,clientId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateClientGoalMutationResult = NonNullable<Awaited<ReturnType<typeof updateClientGoal>>>
    export type UpdateClientGoalMutationBody = BodyType<ClientGoalDto>
    export type UpdateClientGoalMutationError = ErrorType<unknown>

    export const useUpdateClientGoal = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateClientGoal>>, TError,{userId: string;clientId: number;id: number;data: BodyType<ClientGoalDto>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateClientGoal>>,
        TError,
        {userId: string;clientId: number;id: number;data: BodyType<ClientGoalDto>},
        TContext
      > => {
      return useMutation(getUpdateClientGoalMutationOptions(options), queryClient);
    }
    /**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_CLIENT_SERVICE, ROLE_REPORT_ADMIN**<br /><br />
 */
export const deleteClientGoal = (
    userId: string,
    clientId: number,
    id: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/${userId}/clients/${clientId}/goals/${id}`, method: 'DELETE', signal
    },
      options);
    }



export const getDeleteClientGoalMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteClientGoal>>, TError,{userId: string;clientId: number;id: number}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteClientGoal>>, TError,{userId: string;clientId: number;id: number}, TContext> => {

const mutationKey = ['deleteClientGoal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteClientGoal>>, {userId: string;clientId: number;id: number}> = (props) => {
          const {userId,clientId,id} = props ?? {};

          return  deleteClientGoal(userId,clientId,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteClientGoalMutationResult = NonNullable<Awaited<ReturnType<typeof deleteClientGoal>>>

    export type DeleteClientGoalMutationError = ErrorType<unknown>

    export const useDeleteClientGoal = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteClientGoal>>, TError,{userId: string;clientId: number;id: number}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteClientGoal>>,
        TError,
        {userId: string;clientId: number;id: number},
        TContext
      > => {
      return useMutation(getDeleteClientGoalMutationOptions(options), queryClient);
    }
    /**
 * Authorities: **Any authenticated role**
 */
export const getClientGoals = (
    userId: string,
    clientId: number,
    params?: GetClientGoalsParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PagedModelClientGoalDto>(
      {url: `/api/${userId}/clients/${clientId}/goals`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetClientGoalsQueryKey = (userId: string,
    clientId: number,
    params?: GetClientGoalsParams,) => {
    return [
    `/api/${userId}/clients/${clientId}/goals`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetClientGoalsQueryOptions = <TData = Awaited<ReturnType<typeof getClientGoals>>, TError = ErrorType<unknown>>(userId: string,
    clientId: number,
    params?: GetClientGoalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientGoals>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientGoalsQueryKey(userId,clientId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientGoals>>> = ({ signal }) => getClientGoals(userId,clientId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: !!(userId && clientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClientGoals>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetClientGoalsQueryResult = NonNullable<Awaited<ReturnType<typeof getClientGoals>>>
export type GetClientGoalsQueryError = ErrorType<unknown>


export function useGetClientGoals<TData = Awaited<ReturnType<typeof getClientGoals>>, TError = ErrorType<unknown>>(
 userId: string,
    clientId: number,
    params: undefined |  GetClientGoalsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientGoals>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientGoals>>,
          TError,
          Awaited<ReturnType<typeof getClientGoals>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientGoals<TData = Awaited<ReturnType<typeof getClientGoals>>, TError = ErrorType<unknown>>(
 userId: string,
    clientId: number,
    params?: GetClientGoalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientGoals>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientGoals>>,
          TError,
          Awaited<ReturnType<typeof getClientGoals>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientGoals<TData = Awaited<ReturnType<typeof getClientGoals>>, TError = ErrorType<unknown>>(
 userId: string,
    clientId: number,
    params?: GetClientGoalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientGoals>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetClientGoals<TData = Awaited<ReturnType<typeof getClientGoals>>, TError = ErrorType<unknown>>(
 userId: string,
    clientId: number,
    params?: GetClientGoalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientGoals>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetClientGoalsQueryOptions(userId,clientId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_CLIENT_SERVICE, ROLE_REPORT_ADMIN**<br /><br />
 */
export const createClientGoal = (
    userId: string,
    clientId: number,
    clientGoalDto: BodyType<ClientGoalDto>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ClientGoalDto>(
      {url: `/api/${userId}/clients/${clientId}/goals`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: clientGoalDto, signal
    },
      options);
    }



export const getCreateClientGoalMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createClientGoal>>, TError,{userId: string;clientId: number;data: BodyType<ClientGoalDto>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof createClientGoal>>, TError,{userId: string;clientId: number;data: BodyType<ClientGoalDto>}, TContext> => {

const mutationKey = ['createClientGoal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createClientGoal>>, {userId: string;clientId: number;data: BodyType<ClientGoalDto>}> = (props) => {
          const {userId,clientId,data} = props ?? {};

          return  createClientGoal(userId,clientId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateClientGoalMutationResult = NonNullable<Awaited<ReturnType<typeof createClientGoal>>>
    export type CreateClientGoalMutationBody = BodyType<ClientGoalDto>
    export type CreateClientGoalMutationError = ErrorType<unknown>

    export const useCreateClientGoal = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createClientGoal>>, TError,{userId: string;clientId: number;data: BodyType<ClientGoalDto>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createClientGoal>>,
        TError,
        {userId: string;clientId: number;data: BodyType<ClientGoalDto>},
        TContext
      > => {
      return useMutation(getCreateClientGoalMutationOptions(options), queryClient);
    }
